import moment from 'moment'

const monthArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export function millisecondsToHuman(s) {
  const secs = s % 60
  s = (s - secs) / 60
  const mins = s % 60
  const hrs = (s - mins) / 60
  return hrs + 'hrs ' + mins + 'm ' + secs.toFixed(1) + 's'
}

export function GetFromLS(param) {
  const values = localStorage.getItem('reduxPersist:auth')
  if(values === null) return null
  const auth = JSON.parse(values)
  return auth[param]
}

export function isNullish(value){
  if(!value) return true
  if(typeof value === 'undefined') return true
  if(Object.keys(value).length === 0) return true
  return false
}

export function GetPercentage(num, total) {
  const p = num * 100 / total
  return p > 0 ? ` +${p.toFixed(1)}%` : ''
}

function AddDashes(e){
  // Api is removing dashes, need to add them back in 🤷
  return `${e.slice(0,4)}-${e.slice(4,6)}-${e.slice(6,8)}`
}

export function GetParsedDate(e){
  return moment(Date.parse(AddDashes(e))).format('MMM D')
}
export function GetParsedDateAnalytics(e){
  let month = e.slice(4,6).replace(/^0+/, '');
  let day = e.slice(6,8).replace(/^0+/, '');
  return `${monthArr[month-1]} ${day}`
}

export function trim(string, length = 80){
  return string.length > length ?
  string.substring(0, length - 3) + "..." :
  string;
}